/*
  Zulauf / Vorbestellung pro Variante (marielove)
  Daten: snippets/zulauf-variant-data.liquid, Regel: snippets/zulauf-state.liquid
  Läuft nach theme.js#updateCartButton (Container-Event 'variantChange' feuert vor
  dem Document-Event 'variant:change') und überschreibt Button + Hinweise passend
  zum Zulauf-Status der gewählten Variante.
*/
(function () {
  if (window.__zulaufVariantsInit) return;
  window.__zulaufVariantsInit = true;

  // Icon im Button merken – theme.js#updateCartButton setzt textContent und entfernt es
  document.querySelectorAll('[data-add-to-cart-text]').forEach(function (el) {
    var img = el.querySelector('img');
    if (img) el._zulaufIcon = img;
  });

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function findData(variantId) {
    var nodes = document.querySelectorAll('script[data-zulauf-variants]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = nodes[i]._zulauf || (nodes[i]._zulauf = JSON.parse(nodes[i].textContent));
        if (data.variants && data.variants[variantId]) {
          return { el: nodes[i], data: data, v: data.variants[variantId] };
        }
      } catch (e) { /* ungültiges JSON ignorieren */ }
    }
    return null;
  }

  function apply(variant) {
    if (!variant || !variant.id) return;
    var found = findData(variant.id);
    if (!found) return;

    var state = found.v.state;
    var strings = found.data.strings;
    var productId = found.el.dataset.productId;
    var scope = found.el.closest('[data-section-id]') || document;

    // Button
    var prev = found.el.previousElementSibling;
    var form = (prev && prev.tagName === 'FORM') ? prev : scope.querySelector('form[action*="/cart/add"]');
    var btn = form && form.querySelector('[data-add-to-cart]');
    var btnText = btn && btn.querySelector('[data-add-to-cart-text]');
    if (btn && btnText) {
      var icon = btnText._zulaufIcon || btnText.querySelector('img');
      var label;
      if (state === 'soldout') {
        btn.disabled = true;
        btn.classList.add('disabled');
        btn.type = 'button';
        label = strings.soldOut;
      } else if (variant.available) {
        btn.disabled = false;
        btn.classList.remove('disabled');
        btn.type = 'submit';
        label = state === 'preorder' ? strings.preorder : btnText.dataset.defaultText;
      } else {
        label = strings.soldOut;
      }
      btn.classList.toggle('btn--preorder', state === 'preorder');
      btnText.textContent = '';
      if (icon) btnText.appendChild(icon);
      btnText.appendChild(document.createTextNode(' ' + label));
    }

    // Vorbestell-Box + verstecktes Property
    var box = form && form.querySelector('[data-zulauf-preorder-box]');
    if (box) {
      box.hidden = state !== 'preorder';
      var regular = box.querySelector('[data-zulauf-price-regular]');
      var sale = box.querySelector('[data-zulauf-price-sale]');
      var price = found.v.price;
      if (regular) regular.innerHTML = formatMoney(price);
      if (sale) sale.innerHTML = formatMoney(price - Math.floor(price * 0.2));
    }
    var input = form && form.querySelector('[data-zulauf-preorder-input]');
    if (input) input.disabled = state !== 'preorder';

    // Lagerhinweis / Lieferzeit
    var sales = scope.querySelector('[data-zulauf-sales-point][data-product-id="' + productId + '"]');
    if (sales) {
      sales.classList.toggle('hide', found.v.qty < 1);
      sales.querySelectorAll('[data-zulauf-show]').forEach(function (el) {
        el.hidden = el.dataset.zulaufShow !== (state === 'preorder' ? 'preorder' : 'normal');
      });
    }
  }

  document.addEventListener('variant:change', function (evt) {
    apply(evt.detail && evt.detail.variant);
  });
})();

